// carousel_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["icon", "scrollIndicator"]

  connect() {
    this.iconTargets.forEach(icon => {
      icon.addEventListener("mouseenter", () => {
        icon.style.transform = "translateY(-3px)"
      })
      icon.addEventListener("mouseleave", () => {
        icon.style.transform = "translateY(0)"
      })
    })
  }

  scrollToContent() {
    const heroSection = this.element.closest('.hero-section') || this.element
    const heroHeight = heroSection.offsetHeight
    
    window.scrollTo({
      top: heroHeight,
      behavior: 'smooth'
    })
  }
}